import {createFileRoute} from '@tanstack/react-router';
import {BillOBPaymentStatusPage} from 'pages/bills/BillPaymentStatusPage/BillOBPaymentStatusPage';

export const Route = createFileRoute('/_protected/home/bills/$id/open-banking')(
  {
    component: BillOBPaymentStatusPage,
  },
);
